export enum AccionModificacionFeriado
{
  Alta = 0,
  Modificacion = 1
}
